module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchBox":{"link":"Více informací o prodejně"}},"de":{"BranchBox":{"link":"Mehr Informationen über den Shop"}},"sk":{"BranchBox":{"link":"Viac informácií o predajni"}}}')
  delete Component.options._Ctor
}
